module.exports = __webpack_public_path__ + "lazerProduct.webp?72d6a6fcd65c76afa5ff69932472cac3";